export default function Link() {
  return {
    MuiLink: {
      defaultProps: {
        underline: 'hover'
      },

      styleOverrides: {
        root: {
          // color: 'blue', // Links souldn't be primary to avoid shitty self-explanatory design
          cursor: 'default'
        }
      }
    }
  };
}
